import { Modal } from 'antd';

class dialog {
    confirm(message, onOk, onCancel) {
        Modal.confirm({
            keyboard: false,
            title: 'Confirmación',
            content: (message),
            // cancelButtonProps: { disabled: true },
            onOk() {
                if (onOk !== undefined && onOk !== null) {
                    return new Promise(async (resolve, reject) => {
                        await onOk();
                        reject();
                        resolve();
                    }).catch(() => console.log('Oops errors!'));
                }
            },
            onCancel() {
                if (onCancel !== undefined && onCancel !== null) {
                    return new Promise(async (resolve, reject) => {
                        await onCancel();
                        reject();
                        resolve();
                    }).catch(() => console.log('Oops errors!'));
                }
            }
        });
    };

    info(message, onOk) {
        Modal.info({
            keyboard: false,
            title: 'Mensaje',
            content: (message),
            onOk() {
                if (onOk !== undefined && onOk !== null)
                    onOk();
            },
        });
    };

    infoTitle(title, message, onOk) {
        Modal.info({
            keyboard: false,
            title: title,
            content: (message),
            onOk() {
                if (onOk !== undefined && onOk !== null)
                    onOk();
            },
        });
    };

    success(message, onOk) {
        Modal.success({
            keyboard: false,
            title: 'Mensaje',
            content: (message),
            onOk() {
                if (onOk !== undefined && onOk !== null)
                    onOk();
            },
        });
    };

    error(message, onOk) {
        Modal.error({
            keyboard: false,
            title: 'Mensaje',
            content: (message),
            onOk() {
                if (onOk !== undefined && onOk !== null)
                    onOk();
            },
        });
    };

    warning(message, onOk) {
        Modal.warning({
            keyboard: false,
            title: 'Mensaje',
            content: (message),
            onOk() {
                if (onOk !== undefined && onOk !== null) {
                    return new Promise(async (resolve, reject) => {
                        await onOk();
                        reject();
                        resolve();
                    }).catch(() => console.log('Oops errors!'));
                }
            }
        });
    };
}
export default new dialog();